/**
 * This file is auto-generated from formatRelativeDate.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
import { pluralizationEn, pluralizationPl } from '@nzyme/i18n-core';
export const justNow = lang => {
    switch (lang) {
        case 'en':
            return 'Just now';
        case 'pl':
            return 'Przed chwilą';
    }
};
const minutesAgo_en = {
    one: () => 'a minute ago',
    many: params => [params.count, ' minutes ago'],
};
const minutesAgo_pl = {
    one: params => [params.count, ' minutę temu'],
    few: params => [params.count, ' minuty temu'],
    many: params => [params.count, ' minut temu'],
};
export const minutesAgo = (lang, params) => {
    switch (lang) {
        case 'en':
            return pluralizationEn.pluralize(params.count, minutesAgo_en)?.(params);
        case 'pl':
            return pluralizationPl.pluralize(params.count, minutesAgo_pl)?.(params);
    }
};
export const today = lang => {
    switch (lang) {
        case 'en':
            return 'Today';
        case 'pl':
            return 'Dzisiaj';
    }
};
export const yesterday = lang => {
    switch (lang) {
        case 'en':
            return 'Yesterday';
        case 'pl':
            return 'Wczoraj';
    }
};
export const atTime = (lang, params) => {
    switch (lang) {
        case 'en':
            return [params.date, ' at ', params.time];
        case 'pl':
            return [params.date, ', ', params.time];
    }
};
const inMinutes_en = {
    one: () => 'in a minute',
    many: params => ['in ', params.count, ' minutes'],
};
const inMinutes_pl = {
    one: params => ['za ', params.count, ' minutę'],
    few: params => ['za ', params.count, ' minuty'],
    many: params => ['za ', params.count, ' minut'],
};
export const inMinutes = (lang, params) => {
    switch (lang) {
        case 'en':
            return pluralizationEn.pluralize(params.count, inMinutes_en)?.(params);
        case 'pl':
            return pluralizationPl.pluralize(params.count, inMinutes_pl)?.(params);
    }
};
export const tomorrow = lang => {
    switch (lang) {
        case 'en':
            return 'Tomorrow';
        case 'pl':
            return 'Jutro';
    }
};
//# sourceMappingURL=formatRelativeDate.loc.js.map